import { onMounted, onUnmounted } from 'vue';
import { registerEscapeKeyHandler, type EscapeKeyHandlerOptions } from '../utils/escape-key-registry';

export function useEscapeKey(options: EscapeKeyHandlerOptions): void {
	let unregister: (() => void) | null = null;

	onMounted(() => {
		unregister = registerEscapeKeyHandler(options);
	});

	onUnmounted(() => {
		unregister?.();
		unregister = null;
	});
}





